import { useHttpClient } from "../http-client";
import { useMutation } from "@tanstack/react-query";
import React from "react";
import { ApiResponse } from "../types/api-response";

export const useUpdateResponseApi = () => {
  const httpClient = useHttpClient();

  const update = React.useCallback(
    async (params: {
      response: ApiResponse;
      organizationId: string;
      isSupervisorMode: boolean;
      themeStructureId: string;
    }): Promise<ApiResponse> => {
      const response = await httpClient.patch(
        `/classifier/responses/${params.response.id}`,
        {
          data: {
            ...params.response,
            attributes: {
              ...params.response.attributes,
              // Explicitly set approved/supervisor_approved to true so the backend
              // records approved_at and the response leaves the unprocessed pool.
              // Without this, set_approver in responses_controller returns early
              // (approved: false is falsy in Ruby) and recently_approved never
              // includes this response, causing the same batch to be re-served.
              approved: !params.isSupervisorMode,
              supervisor_approved: params.isSupervisorMode,
            },
          },
          theme_structure_id: params.themeStructureId,
          supervisor: String(params.isSupervisorMode),
          organization_id: params.organizationId,
        }
      );

      return response.data.data;
    },
    []
  );

  return useMutation({
    mutationFn: update,
  });
};
